import { StarFillIcon, StarIcon } from 'tt-ui-lib/icons';
import styles from './UserInfoReviewsItem.module.scss';

const NO_REVIEWS = 'No reviews';
const ALL_REVIEWS = 'All reviews';

const UserInfoReviewsItem = ({ ranking, reviews }) => (
  <div className={styles.itemWrapper}>
    <div className={styles.iconWrapper}>
      {ranking ? (
        <StarFillIcon style={{ width: 22, height: 22 }} />
      ) : (
        <StarIcon style={{ width: 22, height: 22 }} />
      )}
    </div>
    <div className={styles.ranking}>{ranking ? `${ranking}` : ``}</div>
    <div className={styles.reviews}>{reviews ? `${ALL_REVIEWS} (${reviews})` : NO_REVIEWS}</div>
  </div>
);

export default UserInfoReviewsItem;
